/**
 * Cliente del motor en segundo plano. Cancelar termina el proceso y crea uno nuevo: así una
 * simulación larga nunca bloquea la interfaz.
 */

import * as Comlink from 'comlink';
import type { ConfiguracionDeEjecucion } from '../../nucleo/dominio/ejecucion';
import type { ResultadoEjecucion } from '../../nucleo/escenarios/replicas';
import type { ApiMotor } from '../../trabajador/motor.worker';

export class SimulacionCancelada extends Error {
  constructor() {
    super('Simulación cancelada.');
  }
}

export class ClienteMotor {
  private worker: Worker | null = null;
  private api: Comlink.Remote<ApiMotor> | null = null;
  private rechazarActual: ((e: Error) => void) | null = null;

  private asegurar(): Comlink.Remote<ApiMotor> {
    if (!this.api) {
      this.worker = new Worker(new URL('../../trabajador/motor.worker.ts', import.meta.url), {
        type: 'module',
        name: 'motor-gemba',
      });
      this.api = Comlink.wrap<ApiMotor>(this.worker);
    }
    return this.api;
  }

  simular(
    config: ConfiguracionDeEjecucion,
    alAvanzar: (hechas: number, total: number) => void,
  ): Promise<ResultadoEjecucion> {
    const api = this.asegurar();
    return new Promise<ResultadoEjecucion>((resolver, rechazar) => {
      this.rechazarActual = rechazar;
      api
        .simular(config, Comlink.proxy(alAvanzar))
        .then(resolver, (e: unknown) => rechazar(e instanceof Error ? e : new Error(String(e))))
        .finally(() => {
          this.rechazarActual = null;
        });
    });
  }

  cancelar(): void {
    this.worker?.terminate();
    this.worker = null;
    this.api = null;
    this.rechazarActual?.(new SimulacionCancelada());
    this.rechazarActual = null;
  }
}

let unico: ClienteMotor | null = null;
export function clienteMotor(): ClienteMotor {
  unico ??= new ClienteMotor();
  return unico;
}
